import _taggedTemplateLiteral from "/drone/src/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";

var _templateObject, _templateObject2, _templateObject3;

import styled, { css } from 'styled-components';
import { marginAttributes, propsBlocker, color } from '../../system';
import { reset } from '../../system/mixins';

var getOrientationStyle = function getOrientationStyle(_ref) {
  var vertical = _ref.vertical;

  if (vertical) {
    return css(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n            width: 1px;\n            height: 100%;\n        "])));
  }

  return css(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n        height: 1px;\n    "])));
};

export var DividerRoot = styled.div.withConfig(propsBlocker)(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n    ", ";\n    background-color: ", ";\n    ", ";\n    ", ";\n"])), reset, color('neutral.03'), getOrientationStyle, marginAttributes);